import FormItem from "@components/FormItem/FormItem";
import { VNominationDocumentTypes, type VNominationDocumentType } from "@constants/certificates";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import {
  FORM_FIELDS,
  REMARKS_INSTRUCTIONS_MAX_CHARS,
  type VesselNominationOutletContext,
} from "../../constants";
import AdditionalDocumentsCard from "./AdditionalDocumentsCard";
import Document from "./DocumentCard";

export const DOCUMENT_TYPES = Object.values(VNominationDocumentTypes) as VNominationDocumentType[];

const Documents = () => {
  const { t } = useTranslation();
  const { formData, updateFormData } = useOutletContext<VesselNominationOutletContext>();

  return (
    <FormProvider {...formData}>
      <div data-testid="documents-page" className="flex flex-col gap-8 pb-8">
        {DOCUMENT_TYPES.map((documentType) => (
          <Document
            key={documentType}
            documentType={documentType}
            label={`vessel-nomination.add.form.sections.${documentType}`}
          />
        ))}
        <FormItem
          type="textarea"
          name={FORM_FIELDS.REMARKS}
          label={t("vessel-nomination.add.form.fields.remarks")}
          testId="vessel-nomination-remarks-instructions"
          maxChars={REMARKS_INSTRUCTIONS_MAX_CHARS}
          minRows={3}
          onFieldChange={updateFormData}
          showCharCounter
        />
        <AdditionalDocumentsCard />
      </div>
    </FormProvider>
  );
};

export default Documents;
